import React from 'react'

import { FormattedMessage, useIntl } from '@divvy-web/i18n'

import MarketingContent, { MarketingQuote } from '@sputnik/components/MarketingContent'
import { PRODUCT_CONST_STRINGS } from '@sputnik/resources/constants'

const GetToKnowYouMarketingContent = () => {
  const { formatMessage } = useIntl()

  return (
    <MarketingContent
      image={{
        alt: formatMessage({
          defaultMessage: 'two people looking at a tablet',
          id: 'sputnik.GetToKnowYouMarketingContent__3VUebS',
        }),
        src: 'https://app.divvy.co/assets/stock-photos/credit-application-get-to-know-you-marketing-content.png',
        isRounded: true,
      }}
      pillText={
        <FormattedMessage
          defaultMessage='Testimonial'
          id='sputnik.GetToKnowYouMarketingContent__UJ4Qnf'
        />
      }
    >
      <MarketingQuote
        designation={
          <FormattedMessage
            defaultMessage='Bookkeeper, Walker & Company'
            id='sputnik.GetToKnowYouMarketingContent__rdmd9Y'
          />
        }
        name={
          <FormattedMessage
            defaultMessage='Samantha Thomas'
            id='sputnik.GetToKnowYouMarketingContent__0bTxdt'
          />
        }
        quote={
          <FormattedMessage
            defaultMessage='“{BILL} has streamlined the time that it takes me to do my job by <strong>at least 70%</strong>.”'
            id='sputnik.GetToKnowYouMarketingContent__VHyn5W'
            values={{
              BILL: PRODUCT_CONST_STRINGS.BILL,
              strong: (chunks) => <b>{chunks}</b>,
            }}
          />
        }
      />
    </MarketingContent>
  )
}

export default GetToKnowYouMarketingContent
